<template>
  <Nav-bar :has_back="true" :has_right="false" title="订单详情"></Nav-bar>
  <div class="order-details-container">
    <!-- 支付状态和费用明细 -->
    <div class="payment-summary">
      <div class="payment-status">
        <div class="status-left">
          <img :src="getStatusIcon()" class="status-icon" />
          <span class="status-text" :class="getStatusClass()">{{
            getStatusText()
          }}</span>
        </div>
        <div
          style="color: #1a1a1a; font-size: 16px"
          v-if="
            state.occupancyStatus !== 'completed' &&
            state.occupancyStatus !== 'skip'
          "
        >
          等待占位费结算
        </div>
        <div class="amount" v-else>
          {{ state.amount }}<span class="unit">元</span>
        </div>
      </div>

      <div class="divider-line"></div>

      <div class="cost-breakdown">
        <div class="breakdown-item">
          <span class="label">电费</span>
          <span class="value">{{ state.total_charging_amount }}元</span>
        </div>
        <div class="breakdown-item">
          <span class="label">服务费</span>
          <span class="value">{{ state.total_service_amount }}元</span>
        </div>
        <div class="breakdown-item" v-if="state.occupancyStatus !== 'skip'">
          <span class="label">超时占位费</span>
          <span
            style="color: #ff4d4f"
            v-if="
              state.occupancyStatus !== 'completed' &&
              state.occupancyStatus !== 'skip'
            "
            >计费中</span
          >
          <span class="value" v-else>{{ state.occupancy_amount }}元</span>
        </div>
      </div>

      <div class="detail-button">
        <button class="detail-btn" @click="goToOrderDetails">
          查看详细明细
        </button>
      </div>
    </div>

    <!-- 充电信息 -->
    <div class="charging-section">
      <div class="section-title">
        {{ state.charge.pile_type == "dc" ? "直流" : "交流" }}充电
      </div>
      <div class="charging-content">
        <div class="charging-time-info">
          <div class="time-item">
            <div class="date">{{ state.startChargingDate }}</div>
            <div class="time">{{ state.startChargingTime }}</div>
            <div class="label">开始充电</div>
          </div>
          <div class="time-connector">
            <div class="connector-top-label">{{ state.chargingDuration }}</div>
            <div class="connector-line-container">
              <div class="connector-dot start"></div>
              <div class="connector-line"></div>
              <div class="connector-dot end"></div>
            </div>
            <div class="connector-bottom-label">{{ state.totalPower }}度</div>
          </div>
          <div class="time-item">
            <div class="date">{{ state.completedDate }}</div>
            <div class="time">{{ state.completedTime }}</div>
            <div class="label">结束充电</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 超时占位费信息 -->
    <div class="timeout-section" v-if="occupancyStatus !== 'skip'">
      <div class="timeout-free" v-if="state.occupancyRule != null">
        前{{ state.occupancyRule.grace_period_min }}分钟免费
      </div>
      <div class="section-title">超时占位费</div>
      <div class="timeout-content">
        <div class="charging-time-info">
          <div class="time-item">
            <div class="date">{{ state.occupancyStartDate }}</div>
            <div class="time">{{ state.occupancyStartTime }}</div>
            <div class="label">开始占位</div>
          </div>
          <div class="time-connector red-connector">
            <div class="connector-top-label" v-if="occupancyStatus === 'completed'">
              {{ state.occupancyDuration || "1分钟" }}
            </div>
            <div class="connector-line-container">
              <div class="connector-dot start red"></div>
              <div class="connector-line red"></div>
              <div class="connector-dot end red"></div>
            </div>
            <div class="connector-bottom-label">{{ state.occupancyRate }}</div>
          </div>
          <div class="time-item">
            <div
              v-if="
                state.occupancyStatus !== 'completed' &&
                state.occupancyStatus !== 'skip'
              "
            >
              <div class="date">--</div>
              <div class="time">计时中</div>
            </div>
            <div v-else>
              <div class="date">{{ state.occupancyEndDate }}</div>
              <div class="time">{{ state.occupancyEndTime }}</div>
            </div>

            <div class="label">结束占位</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 充电站信息 -->
    <div class="station-info">
      <div class="station-header clickable-row" @click="toStation">
        <div class="station-icon">
          <img src="@/images/station_icon.png" alt="充电站" />
        </div>
        <div class="station-main">
          <div class="station-name">{{ state.ordersStation.name }}</div>
          <div class="station-address">
            {{ state.ordersStation.address || "暂无" }}
          </div>
        </div>
        <svg
          class="arrow-icon"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M9 18l6-6-6-6"
            stroke="#c8c9cc"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <div class="station-details">
        <div class="detail-row clickable-row" @click="toChargeDetails">
          <span class="detail-label">充电电桩</span>
          <span class="detail-value"
            >{{ state.charge.serial_number }}->{{ state.charge.name }}</span
          >
          <svg
            class="arrow-icon-small"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M9 18l6-6-6-6"
              stroke="#c8c9cc"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div class="detail-row">
          <span class="detail-label">结算原因</span>
          <span class="detail-value">{{ state.closeReasonText }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">付款方式</span>
          <span class="detail-value">余额支付</span>
          <van-icon name="arrow" size="12" color="#c8c9cc" />
        </div>
        <div class="detail-row order-number">
          <span class="detail-label">订单编号</span>
          <span class="detail-value">{{ state.ordersTradeNumber }}</span>
          <span class="copy-btn" @click="copyOrderNumber">复制</span>
        </div>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="bottom-buttons">
      <button class="contact-btn" @click="contactCustomerService">
        联系客服
      </button>
      <button
        class="pay-btn"
        v-if="state.orderStatus === 'unpaid'"
        @click="payOrder"
      >
        立即支付
      </button>
    </div>

    <!-- 底部安全区域 -->
    <div class="bottom-safe-area"></div>
  </div>
</template>

<script>
import NavBar from "../../components/NavBar.vue";
import request from "@/api/request";
import { useRouter } from "vue-router";
import { reactive, onMounted, onUnmounted } from "vue";
import ordersUtils from "@/utils/data.js";
import httpHelper from "@/helpers/http_helper";
import { Toast } from "vant";
let state;
let router;
let pollingTimer = null; // 轮询定时器
export default {
  components: {
    NavBar: NavBar,
  },
  setup() {
    router = useRouter();
    state = reactive({
      ordersDetails: {},
      ordersStation: "",
      ordersTradeNumber: "",
      amount: "",
      occupancy_amount: "",
      total_charging_amount: "",
      total_service_amount: "",
      elapsedTime: "",
      charge: "",
      startChargingDate: "",
      startChargingTime: "",
      completedDate: "",
      completedTime: "",
      chargingDuration: "",
      totalPower: "",
      occupancyStartDate: "",
      occupancyStartTime: "",
      occupancyEndDate: "",
      occupancyEndTime: "",
      occupancyDuration: "",
      occupancyRate: "",
      closeReasonText: "",
      orderStatus: "",
      occupancyDetail: null,
      occupancyStatus: "",
      occupancyRule: null,
    });
    getDetails(router.currentRoute.value.params.id);

    // 组件挂载时开始轮询
    onMounted(() => {
      startPolling();
    });

    // 组件卸载时清除轮询
    onUnmounted(() => {
      stopPolling();
    });

    return {
      state,
      router,
      toStation,
      toChargeDetails,
      payOrder,
      goToOrderDetails,
      getStatusIcon,
      getStatusText,
      getStatusClass,
      copyOrderNumber,
      contactCustomerService,
    };
  },
};
function payOrder() {
  const orderRoute = router.currentRoute.value;
  httpHelper.showLoading();
  request
    .putPayOders(state.ordersDetails.id)
    .then((res) => {
      httpHelper.hideLoading();
      Toast("支付成功!");
      getDetails(res.data.id);
    })
    .catch((error) => {
      httpHelper.hideLoading();
      const errorData = error.response && error.response.data;
      const message = errorData && (
        errorData.error ||
        errorData.error_msg ||
        (errorData.result && (errorData.result.message || errorData.result))
      );
      if (typeof message === "string" && message.includes("余额不足")) {
        Toast.fail({
          message,
          onClose: () => {
            // 用户已离开当前订单时，不再自动跳转。
            if (router.currentRoute.value === orderRoute) {
              router.push("/user/recharge");
            }
          },
        });
      }
    });
}
function getDetails(id) {
  httpHelper.showLoading();
  request
    .getOrdersDetails(id)
    .then((res) => {
      httpHelper.hideLoading();
      state.ordersDetails = res.data;
      state.ordersStation = res.data.charge_station;
      state.ordersTradeNumber = res.data.trade_number;
      state.amount = res.data.amount;
      state.charge = res.data.charger;
      state.occupancy_amount = res.data.occupancy_amount;
      state.total_charging_amount = res.data.charge_amount;
      state.total_service_amount = res.data.service_amount;
      state.elapsedTime =
        (new Date(res.data.completed_at) -
          new Date(res.data.start_charging_at)) /
        1000;

      // 格式化开始充电时间
      if (res.data.start_charging_at) {
        const startDate = new Date(res.data.start_charging_at);
        state.startChargingDate = ordersUtils.formatDate(startDate);
        state.startChargingTime = ordersUtils.formatTime(startDate);
      }

      // 格式化结束充电时间
      if (res.data.completed_at) {
        const endDate = new Date(res.data.completed_at);
        state.completedDate = ordersUtils.formatDate(endDate);
        state.completedTime = ordersUtils.formatTime(endDate);
      }

      // 计算充电时长
      if (res.data.start_charging_at && res.data.completed_at) {
        const duration =
          new Date(res.data.completed_at) -
          new Date(res.data.start_charging_at);
        state.chargingDuration = ordersUtils.formatDuration(duration);
      }

      // 设置总电量
      state.totalPower = res.data.total_power || "0";

      // 设置结算原因
      state.closeReasonText = getCloseReasonText(res.data.close_reasons);

      // 设置订单状态
      state.orderStatus = res.data.status;
      state.occupancyDetail = res.data.occupancy_detail || null;
      state.occupancyStatus = res.data.occupancy_status || "";
      state.occupancyRule = res.data.occupancy_rule || null;
      // 处理超时占位费时间
      if (state.occupancyDetail && state.occupancyDetail.period) {
        // 占位开始时间
        if (state.occupancyDetail.period.from) {
          const occupancyStartDate = new Date(
            state.occupancyDetail.period.from
          );
          state.occupancyStartDate = ordersUtils.formatDate(occupancyStartDate);
          state.occupancyStartTime = ordersUtils.formatTime(occupancyStartDate);
        }

        // 占位结束时间
        if (state.occupancyDetail.period.to) {
          const occupancyEndDate = new Date(state.occupancyDetail.period.to);
          state.occupancyEndDate = ordersUtils.formatDate(occupancyEndDate);
          state.occupancyEndTime = ordersUtils.formatTime(occupancyEndDate);
        }

        // 占位时长
        if (state.occupancyDetail.duration_min) {
          state.occupancyDuration = `${state.occupancyDetail.duration_min}分钟`;
        }

        // 占位费率
        if (state.occupancyDetail.unit_price) {
          state.occupancyRate = `${state.occupancyDetail.unit_price}元/分钟`;
        }
      }

      state.ordersDetails = res.data;
      state.orderStatusName = ordersUtils.orderStatusName(res.data.status);

      // 检查轮询状态
      checkPollingStatus();
    })
    .catch(() => {
      httpHelper.hideLoading();
    });
}
function toStation() {
  router.push(`/station/details/${state.ordersStation.id}`);
}
function toChargeDetails() {
  router.push(`/station/charge_details/${state.charge.id}`);
}
function goToOrderDetails() {
  router.push(`/user/order_billing_details/${state.ordersDetails.id}`);
}

// 获取结算原因
function getCloseReasonText(closeReasons) {
  if (!closeReasons) {
    return "未知原因";
  }

  const reasonMap = {
    stop_charging_from_user: "用户手动停止充电",
    not_enough_balance: "余额不足",
    offline_order: "离线订单异常",
    cannot_start_charging: "无法启动充电",
    gun_status_changed_to_available: "充电枪状态变更为可用",
    gun_status_changed_to_ready: "充电枪状态变更为就绪",
    charging_completed: "充电完成",
  };

  return reasonMap[closeReasons] || closeReasons || "未知原因";
}

// 根据订单状态获取对应的图标
function getStatusIcon() {
  const statusIconMap = {
    in_progress: require("@/images/charging.gif"),
    unpaid: require("@/images/order_unpaid.png"),
    paid: require("@/images/order_paid.png"),
    closed: require("@/images/order_cancel.png"),
  };

  return (
    statusIconMap[state.orderStatus] || require("@/images/order_unpaid.png")
  );
}

// 根据订单状态获取对应的文本
function getStatusText() {
  return ordersUtils.orderStatusName(state.orderStatus) || "未知状态";
}

// 根据订单状态获取对应的文本颜色类名
function getStatusClass() {
  const statusClassMap = {
    in_progress: "status-charging",
    unpaid: "status-unpaid",
    paid: "status-paid",
    closed: "status-closed",
  };

  return statusClassMap[state.orderStatus] || "status-default";
}

// 复制订单编号到剪贴板
function copyOrderNumber() {
  if (!state.ordersTradeNumber) {
    Toast("订单编号不存在");
    return;
  }

  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard
      .writeText(state.ordersTradeNumber)
      .then(() => {
        Toast("订单编号已复制到剪贴板");
      })
      .catch(() => {
        // 降级到传统方法
        fallbackCopyTextToClipboard(state.ordersTradeNumber);
      });
  } else {
    // 降级到传统方法
    fallbackCopyTextToClipboard(state.ordersTradeNumber);
  }
}

// 降级复制方法（兼容旧浏览器）
function fallbackCopyTextToClipboard(text) {
  const textArea = document.createElement("textarea");
  textArea.value = text;
  textArea.style.position = "fixed";
  textArea.style.left = "-999999px";
  textArea.style.top = "-999999px";
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    const successful = document.execCommand("copy");
    if (successful) {
      Toast("订单编号已复制到剪贴板");
    } else {
      Toast("复制失败，请手动复制");
    }
  } catch (err) {
    Toast("复制失败，请手动复制");
  }

  document.body.removeChild(textArea);
}

// 联系客服 - 拨打充电站电话
function contactCustomerService() {
  if (!state.ordersStation || !state.ordersStation.phone) {
    Toast("暂无客服电话");
    return;
  }

  const phoneNumber = state.ordersStation.phone;
  window.location.href = `tel:${phoneNumber}`;
}

// 开始轮询
function startPolling() {
  // 如果订单状态为unpaid且占位费状态不为completed，则开始轮询
  if (shouldStartPolling()) {
    pollingTimer = setInterval(() => {
      getDetails(router.currentRoute.value.params.id);
    }, 5000); // 每5秒轮询一次
  }
}

// 检查轮询状态
function checkPollingStatus() {
  if (shouldStartPolling()) {
    // 需要轮询但还没开始，则开始轮询
    if (!pollingTimer) {
      startPolling();
    }
  } else {
    // 不需要轮询，停止轮询
    stopPolling();
  }
}

// 停止轮询
function stopPolling() {
  if (pollingTimer) {
    clearInterval(pollingTimer);
    pollingTimer = null;
  }
}

// 判断是否需要开始轮询
function shouldStartPolling() {
  return (
    state.orderStatus === "in_progress" &&
    state.occupancyStatus !== "skip" &&
    state.occupancyStatus !== "completed"
  );
}
</script>

<style lang="scss" scoped>
.order-details-container {
  padding: 16px;
  padding-top: 60px;
  padding-bottom: 100px;
  background-color: #f5f5f5;
  min-height: 100vh;
}
.status-icon {
  width: 22px;
  height: 22px;
}

.payment-summary {
  background: white;
  border-radius: 12px;
  padding: 20px 16px;
  margin-bottom: 16px;

  .payment-status {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;

    .status-left {
      display: flex;
      align-items: center;

      .status-text {
        font-size: 16px;
        font-weight: 500;
        margin-left: 8px;

        &.status-charging {
          color: #ff6b35; // 充电中
        }

        &.status-unpaid {
          color: #ee0a24; // 未支付
        }

        &.status-paid {
          color: #1a1a1a; // 已支付
        }

        &.status-closed {
          color: #969799; // 已关闭
        }

        &.status-default {
          color: #1a1a1a;
        }
      }
    }

    .amount {
      font-size: 28px;
      font-weight: bold;
      color: #333;

      .unit {
        font-size: 16px;
        font-weight: normal;
        margin-left: 2px;
      }
    }
  }

  .divider-line {
    height: 1px;
    background: none;
    border-top: 1px dashed #e5e5e5;
    margin: 16px 0;
  }

  .cost-breakdown {
    .breakdown-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 8px 0;

      .label {
        font-size: 14px;
        color: #666;
      }

      .value {
        font-size: 14px;
        color: #333;
        font-weight: 500;
      }
    }
  }

  .detail-button {
    text-align: center;
    margin-top: 20px;
  }

  .detail-btn {
    background: #ffffff;
    color: #999999;
    border: 1px solid #e0e0e0;
    border-radius: 20px;
    padding: 8px 16px;
    font-size: 14px;
    cursor: pointer;
    outline: none;
    transition: all 0.3s ease;

    &:hover {
      background: #f5f5f5;
    }

    &:active {
      background: #e8e8e8;
    }
  }
}

.charging-section {
  background: white;
  border-radius: 12px;
  padding: 20px 16px 0;
  margin-bottom: 16px;

  .section-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-bottom: 16px;
  }

  .charging-content {
    background: #e8f4ff;
    border-radius: 8px;
    padding: 16px;
    margin: 0 -16px 20px;
  }

  .charging-time-info {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .time-item {
      text-align: center;
      flex: 1;

      .date {
        font-size: 12px;
        color: #999;
        margin-bottom: 2px;
      }

      .time {
        font-size: 20px;
        font-weight: bold;
        color: #333;
        margin-bottom: 2px;
      }

      .label {
        font-size: 12px;
        color: #666;
      }
    }

    .time-connector {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 0 16px;
      position: relative;

      .connector-top-label {
        font-size: 12px;
        color: #1989fa;
        background: #e8f4ff;
        padding: 6px 12px;
        border-radius: 16px;
        margin-bottom: 8px;
        border: 1px solid #d1e9ff;
        font-weight: 500;
      }

      .connector-line-container {
        display: flex;
        align-items: center;
        width: 100%;
        position: relative;

        .connector-dot {
          width: 10px;
          height: 10px;
          background: #1989fa;
          border-radius: 50%;
          z-index: 2;
          border: 2px solid white;
          box-shadow: 0 0 0 1px #1989fa;
        }

        .connector-line {
          flex: 1;
          height: 2px;
          background: none;
          border-top: 2px dashed #007aff;
          margin: 0 -5px;
        }
      }

      .connector-bottom-label {
        font-size: 10px;
        color: #999;
        margin-top: 6px;
      }
    }
  }
}

.timeout-section {
  background: white;
  border-radius: 12px;
  padding: 20px 16px 0;
  position: relative;
  margin-bottom: 16px;

  .timeout-free {
    font-size: 12px;
    color: #666;
    right: 16px;
    top: 20px;
    position: absolute;
  }

  .section-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-bottom: 16px;
  }

  .timeout-content {
    background: #ffe8e8;
    border-radius: 8px;
    padding: 16px;
    margin: 0 -16px 20px;
  }

  .charging-time-info {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .time-item {
      text-align: center;
      flex: 1;

      .date {
        font-size: 12px;
        color: #999;
        margin-bottom: 2px;
      }

      .time {
        font-size: 20px;
        font-weight: bold;
        color: #333;
        margin-bottom: 2px;
      }

      .label {
        font-size: 12px;
        color: #666;
      }
    }

    .time-connector {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 0 16px;
      position: relative;

      .connector-top-label {
        font-size: 12px;
        color: #1989fa;
        background: #e8f4ff;
        padding: 6px 12px;
        border-radius: 16px;
        margin-bottom: 8px;
        border: 1px solid #d1e9ff;
        font-weight: 500;
      }

      &.red-connector .connector-top-label {
        color: #ff4444;
        background: #ffeeee;
        border: 1px solid #ff4444;
      }

      .connector-line-container {
        display: flex;
        align-items: center;
        width: 100%;
        position: relative;

        .connector-dot {
          width: 10px;
          height: 10px;
          background: #1989fa;
          border-radius: 50%;
          z-index: 2;
          border: 2px solid white;
          box-shadow: 0 0 0 1px #1989fa;

          &.red {
            background: #ff4444;
            box-shadow: 0 0 0 1px #ff4444;
          }
        }

        .connector-line {
          flex: 1;
          height: 2px;
          background: none;
          border-top: 2px dashed #007aff;
          margin: 0 -5px;

          &.red {
            background: none;
            border-top: 2px dashed #ff4444;
            height: 2px;
          }
        }
      }

      .connector-bottom-label {
        font-size: 10px;
        color: #999;
        margin-top: 6px;
      }
    }
  }
}

.station-info {
  background: white;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;

  .station-header {
    display: flex;
    align-items: center;
    padding-bottom: 16px;
    border-bottom: 1px solid #f0f0f0;

    .station-icon {
      width: 40px;
      height: 40px;
      margin-right: 12px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 8px;
      }
    }

    .station-main {
      flex: 1;

      .station-name {
        font-size: 16px;
        color: #333;
        font-weight: 500;
        margin-bottom: 4px;
      }

      .station-address {
        font-size: 12px;
        color: #999;
      }
    }
  }

  .station-details {
    padding-top: 16px;
  }

  .detail-row {
    display: flex;
    align-items: center;
    padding: 10px 0;

    .detail-label {
      font-size: 14px;
      color: #666;
      margin-right: 16px;
    }

    .detail-value {
      font-size: 14px;
      color: #333;
      flex: 1;
    }

    .copy-btn {
      font-size: 12px;
      color: #1989fa;
      padding: 4px 8px;
      border: 1px solid #1989fa;
      border-radius: 4px;
      background: white;
      margin-left: 8px;
      cursor: pointer;
      transition: all 0.2s ease;
      user-select: none;

      &:hover {
        background: #1989fa;
        color: white;
      }

      &:active {
        transform: scale(0.95);
        background: #0c7cd5;
      }
    }

    &.order-number {
      .detail-value {
        word-break: break-all;
        line-height: 1.4;
      }
    }
  }

  .arrow-icon-small {
    flex-shrink: 0;
  }
}

// 可点击行样式
.clickable-row {
  cursor: pointer;
  transition: background-color 0.2s ease;
  border-radius: 8px;
  padding: 4px;
  margin: -4px;

  &:hover {
    background-color: #f7f8fa;
  }

  &:active {
    background-color: #ebedf0;
  }
}

.bottom-buttons {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  padding: 16px;
  padding-bottom: calc(16px + env(safe-area-inset-bottom));
  display: flex;
  gap: 12px;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;

  .contact-btn {
    flex: 1;
    height: 44px;
    background: white;
    color: #666;
    border: 1px solid #e0e0e0;
    border-radius: 22px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    outline: none;
    transition: all 0.3s ease;

    &:hover {
      background: #f5f5f5;
    }

    &:active {
      background: #e8e8e8;
      transform: scale(0.98);
    }
  }

  .pay-btn {
    flex: 1;
    height: 44px;
    background: #1989fa;
    color: white;
    border: none;
    border-radius: 22px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    outline: none;
    transition: all 0.3s ease;

    &:hover {
      background: #1976d2;
    }

    &:active {
      background: #1565c0;
      transform: scale(0.98);
    }
  }
}

.bottom-safe-area {
  height: 20px;
  background: #f5f5f5;
}
</style>
